import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  newNotificationReceived: false,
  toggleSidebar: false,
  slideNav: false,
  profileData: {},
  vesselData: {},
  adminFormDetails: {},
  companyFormDetails: {},
  truckTransIds: {},
}

const CommonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    updateNewNotificationFlag: (state, { payload }) => {
      state.newNotificationReceived = payload
    },
    setAppTitle: (state, { payload }) => {
      state.appTitle = payload
    },
    setToggleSidebar: (state, { payload }) => {
      state.toggleSidebar = payload
    },
    setHoverSidebar: (state, { payload }) => {
      state.hoverSidebar = payload
    },
    setSlideNav: (state, { payload }) => {
      state.slideNav = payload
    },
    setProfileDetails: (state, { payload }) => {
      state.profileDetails = payload
    },
    setTruckTransIds: (state, { payload }) => {
      state.truckTransIds = payload
    },
    setCompaniesDetails: (state, { payload }) => {
      state.companiesDetails = payload
    },
    setEditVessleData: (state, { payload }) => {
      state.editVessleData = payload
    },
    setProfileData: (state, { payload }) => {
      state.profileData = payload
    },
    setVesselData: (state, { payload }) => {
      state.vesselData = payload
    },
    setServicerecordData: (state, { payload }) => {
      state.servicerecordData = payload
    },
    setServicerecordAddData: (state, { payload }) => {
      state.servicerecordAddData = payload
    },
    setContactEnable: (state, { payload }) => {
      state.contactEnable = payload
    },
    setAdminFormDetails: (state, { payload }) => {
      state.adminFormDetails = payload
    },
    setCompanyFormDetails: (state, { payload }) => {
      state.companyFormDetails = payload
    },
    setCompanyEmail: (state, { payload }) => {
      state.companyEmail = payload
    },
    setEstimateEditData: (state, { payload }) => {
      state.estimateEditData = payload
    },
    setOrderEditData: (state, { payload }) => {
      state.orderEditData = payload
    },
    setPurchaseOrderEditData: (state, { payload }) => {
      state.purchaseOrderEditData = payload
    },
    setPurchaseEstimateEditData: (state, { payload }) => {
      state.purchaseEstimateEditData = payload
    },
    setInvoiceEditData: (state, { payload }) => {
      state.invoiceEditData = payload
    },
    setPurchaseInvoiceEditData: (state, { payload }) => {
      state.purchaseInvoiceEditData = payload
    },
    setPaymentDetails: (state, { payload }) => {
      state.salesPaymentDetails = payload
    },
    setPurchasePaymentDetails: (state, { payload }) => {
      state.purchasePaymentDetails = payload
    },
  },
})

export const {
  updateNewNotificationFlag,
  setToggleSidebar,
  setHoverSidebar,
  setSlideNav,
  setProfileDetails,
  setTruckTransIds,
  setCompaniesDetails,
  setEditVessleData,
  setVesselData,
  setServicerecordData,
  setServicerecordAddData,
  setContactEnable,
  setAdminFormDetails,
  setCompanyFormDetails,
  setCompanyEmail,
  setEstimateEditData,
  setPurchaseOrderEditData,
  setPurchaseEstimateEditData,

  setOrderEditData,
  setInvoiceEditData,
  setPurchaseInvoiceEditData,
  setPurchasePaymentDetails,
  setAppTitle,
  setPaymentDetails,
  setProfileData,
} = CommonSlice.actions

export default CommonSlice.reducer
